import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import css from './NoSearchResultsMaybe.module.css';

const NoSearchResultsMaybe = props => {
  const { listingsAreLoaded, totalItems, location, resetAll } = props;
  const hasNoResult = listingsAreLoaded && totalItems === 0;
  const hasSearchParams = location.search?.length > 0;
  const searchParams = new URLSearchParams(location?.search);
  const failedSearch = searchParams.get('address') ? searchParams.get('address') : searchParams.get('bounds');

  if (totalItems !== 0) {
    return null;
  }

  if (!hasNoResult) {
    return (
      <div className={css.noSearchResults}>
        <div className={css.card}>
          <span className={css.iconBadge} aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
              <circle cx="11" cy="11" r="7" />
              <path d="m20 20-3.2-3.2" />
            </svg>
          </span>
          <div className={css.copy}>
            <p className={css.title}>
              <FormattedMessage id="MainPanelHeader.NoResult" />
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={css.noSearchResults}
      data-elb="searchp"
      data-elb-searchp={`name:noresultsfor-${failedSearch};`}
      data-elbaction="visible"
    >
      <div className={css.card}>
        <span className={css.iconBadge} aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <circle cx="11" cy="11" r="7" />
            <path d="m20 20-3.2-3.2" />
          </svg>
        </span>
        <div className={css.copy}>
          <p className={css.title}>
            <FormattedMessage id="SearchPage.noExactMatch" />
          </p>
          <p className={css.subtitle}>
            <FormattedMessage id="SearchPage.loosenFilters" />
          </p>
        </div>
        {hasSearchParams ? (
          <button className={css.resetAllFiltersButton} onClick={e => resetAll(e)}>
            <FormattedMessage id="SearchPage.resetAllFilters" />
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default NoSearchResultsMaybe;
